const backgrounds =
[
	{
		"id": "droga5-bg",
		"coordinates": [-74.00614007096057 , 40.70489746069413],
		"imgSrc" :require('./assets/img/droga5.png'),
		"imgName": "droga5"
	}

]


export default backgrounds;


// WEBPACK FOOTER //
// ./src/backgrounds.js